module.exports = __webpack_public_path__ + "img/cv-time.e779d19f.svg";